import { supabase } from '@/integrations/supabase/client';
import { categorizeBook, fetchUserContext, TBRCategory } from './tbrCategorization';

/**
 * Automatically categorizes a book when added to TBR based on page count and genres.
 * This should be called after a book is added to the user_books table with shelf='to-read'.
 */
export async function autoCategorizeTBRBook(
  userId: string,
  bookId: string
): Promise<TBRCategory | null> {
  try {
    // Fetch book details for categorization
    const { data: book, error: bookError } = await supabase
      .from('books')
      .select('page_count, categories, subjects')
      .eq('id', bookId)
      .single();

    if (bookError || !book) {
      console.warn('Could not fetch book for auto-categorization:', bookError);
      return null;
    }

    // Get user context (recent reads)
    const userContext = await fetchUserContext(userId);

    // Determine category
    const category = await categorizeBook(
      {
        page_count: book.page_count ?? undefined,
        categories: book.categories ?? [],
        subjects: book.subjects ?? [],
      },
      userContext
    );

    // Update the user_books entry with the category
    const { error: updateError } = await supabase
      .from('user_books')
      .update({ tbr_category: category })
      .eq('user_id', userId)
      .eq('book_id', bookId)
      .eq('shelf', 'to-read');

    if (updateError) {
      console.warn('Could not update TBR category:', updateError);
      return null;
    }

    return category;
  } catch (error) {
    console.error('Error auto-categorizing TBR book:', error);
    return null;
  }
}
